//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            columns: [
                {
                    name: 'menu',
                    required: true,
                    label: 'Menu',
                    align: 'left',
                    field: 'menu',
                    sortable: true,
                },
                {
                    name: 'active',
                    align: 'left',
                    label: 'Activo',
                    field: 'active',
                    sortable: true,
                },
                {
                    name: 'select',
                    align: 'left',
                    label: 'Seleccionar',
                    field: 'select',
                    sortable: true,
                },
                {
                    name: 'ver',
                    align: 'left',
                    label: 'Ver',
                    field: 'ver',
                    sortable: true,
                },
                {
                    name: 'delete',
                    label: 'Eliminar',
                    align: 'left',
                    field: 'delete',
                },
            ],
        }
    },
}
